/**
 * 个股 WS channel 入口：仅做各 channel 公开 API 的 re-export，不再持有跨 channel 的 registry / manager。
 *
 * 设计目标：
 * - 协议层（每个 channel + RealtimeSubscriber）与业务层（vuex / hooks / 指令）解耦；
 * - 多 channel 编排（fields 反查、idle 回调）下沉到业务层（如 stock vuex）；
 * - 后续新增 channel 时新建 `xxxChannel.js` 并在此 re-export 即可，调用方零改动。
 *
 * @module utils/realtime/stockChannels
 */

export { SecChannelSubscriber, getSecChannelSubscriber } from './secChannel';

export { HeaderDetailChannelSubscriber, getHeaderDetailChannelSubscriber } from './headerDetailChannel';

export { StockKlineChannelSubscriber, getStockKlineChannelSubscriber } from './stockKlineChannel';

export { installMarketTipsChannel } from './marketTipsChannel';

/**
 * 业务侧默认订阅字段（价 + 涨跌幅），用于 v-stock-realtime 等无明确 fields 的展示场景。
 * 与 SEC channel 的字段子集对齐；如未来分裂到多 channel，调用方需要显式指定。
 */
export const STOCK_REALTIME_DEFAULT_FIELDS = Object.freeze(['lastPrice', 'changePct']);
